import React, { Component } from 'react';
import {
  Button, Card, CardBody, Col, Table, Row, UncontrolledTooltip, Alert,
} from 'reactstrap';
import { Link, Redirect } from 'react-router-dom';
import Moment from 'moment';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import swal from 'sweetalert';
import DatePicker from 'react-datepicker';
import CalendarIcon from 'mdi-react/CalendarIcon';

// import AddInventoryModal from './AddInventoryModal';
import AddTransactionModal from '../../components/AddTransactionModal';
import AddInventoryModal from '../../components/AddInventoryModal';
import InventoryService from '../../../../services/InventoryService';
import CommonService from '../../../../services/CommonService';
import global from '../../../../global';
import InventoryReport from './InventoryReport';

class WarehouseDashboard2 extends Component {
  static propTypes = {
    itemID: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.userdata = JSON.parse(localStorage.getItem('userData'));
    const { itemID } = this.props;
    this.currDate = new Date();
    const locationId = global.parseToNumber(this.userdata.location_id) !== 0 && ((['1', '5', '6'].indexOf(this.userdata.type) > -1) === true) ? this.userdata.location_id : itemID;
    this.state = {
      list: [],
      modal: false,
      warehouseData: {
        warehouseName: 'Inventory',
        receiving_report: '0',
        withdrawal_report: '0',
        total_transfer: '0',
        stock_balance: '0',
        grand_total: '0',
      },
      formdata: {
        productName: '',
        batchCode: '',
        roomName: '',
        perKilo: '',
        unitCost: '',
        supplierName: '',
        deliveryDate: this.currDate,
        deliveryDate_txt: Moment(this.currDate).format('YYYY-MM-DD HH:mm:ss'),
        inventoryDate: this.currDate,
        inventoryDate_txt: Moment(this.currDate).format('YYYY-MM-DD HH:mm:ss'),
        added_by: this.userdata.user_id,
        location_id: locationId,
      },
      title: 'Add',
      errorMsg: '',
      goTo: false,
      goToPage: '/',
    };
    this.isLoading = false;
    this.locationID = locationId;
    this.toggleModal = this.toggleModal.bind(this);
    this.addToggle = this.addToggle.bind(this);
    this.addSubmitForm = this.addSubmitForm.bind(this);
    this.addTransaction = this.addTransaction.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.executeModal = '';
    this.changeInventoryDate = this.changeInventoryDate.bind(this);
    this.noreports = false;
    this.reportdate = '';
  }

  componentDidMount() {
    this.isLoading = true;
    this.onLoadInventory();
  }

  componentWillUnmount() {
    this.isLoading = false;
  }

  onLoadInventory = async (invtDate = '') => {
    try {
      const storageData = JSON.parse(localStorage.getItem('warehouseInventoryDate'));
      const deliveryDate = invtDate !== '' ? invtDate : storageData !== null && invtDate === '' ? storageData.date : Moment(new Date()).format('YYYY-MM-DD');
      localStorage.setItem('warehouseInventoryDate', JSON.stringify({ type: 'warehouse', date: deliveryDate }));

      const response = await InventoryService.getWarehouseInventory2(this.locationID, deliveryDate);
      if (this.isLoading && response) {
        this.noreports = response.noreports;
        this.reportdate = Moment(response.last_reportdate).format('MMMM DD, YYYY');

        this.setState({
          list: response.inventory,
          warehouseData: {
            warehouseName: response.location_name,
            receiving_report: response.total_in,
            total_beginning: response.total_beginning,
            withdrawal_report: response.total_out,
            total_transfer: response.total_transfer,
            stock_balance: response.total_stock_balance,
            grand_total: response.grand_total,
          },
        });
      }
    } catch (err) {
      console.log('Error: ', err.message);
    }
    this.isLoading = false;
  }

  handleChange = (e, fieldName) => {
    if (fieldName === 'deliver') {
      if (e) {
        this.setState(prevState => ({
          formdata: { ...prevState.formdata, deliverVal: e.value, deliverTxt: e.label },
        }));
      } else {
        this.setState(prevState => ({
          formdata: { ...prevState.formdata, deliverVal: undefined, deliverTxt: undefined },
        }));
      }
    } else if (fieldName === 'product') {
      if (e) {
        this.setState(prevState => ({
          formdata: { ...prevState.formdata, product: e.value, productName: e.label },
        }));
      } else {
        this.setState(prevState => ({
          formdata: { ...prevState.formdata, product: undefined, productName: undefined },
        }));
      }
    } else if (fieldName === 'supplier') {
      this.setState(prevState => ({
        formdata: { ...prevState.formdata, supplier: e.value, supplierName: e.label },
      }));
    } else if (fieldName === 'room') {
      if (e) {
        this.setState(prevState => ({
          formdata: { ...prevState.formdata, room: e.value, roomName: e.label },
        }));
      } else {
        this.setState(prevState => ({
          formdata: { ...prevState.formdata, room: undefined, roomName: undefined },
        }));
      }
    } else if (fieldName === 'number') {
      const { name, value } = e.target;
      this.setState(prevState => ({
        formdata: { ...prevState.formdata, [name]: value.replace(/[^0-9.]/g, '') },
      }));
    } else if (fieldName === 'date') {
      const date = new Date(e);
      const dateText = Moment(date).format('YYYY-MM-DD HH:mm:ss');
      this.setState(prevState => ({
        formdata: {
          ...prevState.formdata, inventoryDate: date, inventoryDate_txt: dateText, deliveryDate: date, deliveryDate_txt: dateText,
        },
      }));
    } else if (fieldName === 'ddate') {
      const date = new Date(e);
      const dateText = Moment(date).format('YYYY-MM-DD HH:mm:ss');
      this.setState(prevState => ({
        formdata: {
          ...prevState.formdata, deliveryDate: date, deliveryDate_txt: dateText,
        },
      }));
    } else if (fieldName === 'idate') {
      const date = new Date(e);
      const dateText = Moment(date).format('YYYY-MM-DD HH:mm:ss');
      this.setState(prevState => ({
        formdata: {
          ...prevState.formdata, inventoryDate: date, inventoryDate_txt: dateText,
        },
      }));
    } else {
      const { name, value } = e.target;
      this.setState(prevState => ({
        formdata: { ...prevState.formdata, [name]: value },
      }));
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({
      formdata: {
        productName: '',
        batchCode: '',
        roomName: '',
        perKilo: '',
        unitCost: '',
        supplierName: '',
      },
    });
  };

  goTo = (ev) => {
    this.setState({ goTo: true, goToPage: ev.currentTarget.dataset.href });
  }

  changeInventoryDate(e) {
    e.preventDefault();
    const { formdata } = this.state;
    const deliveryDate = Moment(formdata.deliveryDate).format('YYYY-MM-DD');
    this.isLoading = true;
    this.onLoadInventory(deliveryDate);
  }

  addToggle() {
    this.executeModal = 'addinventory';
    this.toggleModal('Add');
    this.setState(prevstate => (
      {
        formdata: {
          ...prevstate.formdata,
          productName: '',
          batchCode: '',
          referenceNumber: '',
          roomName: '',
          perKilo: '',
          unitCost: '',
          supplierName: '',
        },
        errorMsg: '',
      }
    ));
    this.handleSubmit = (e) => { this.addSubmitForm(e); };
  }

  addTransaction() {
    this.executeModal = 'addtransaction';
    this.setState(prevstate => (
      {
        formdata: {
          ...prevstate.formdata,
          productName: '',
          batchCode: '',
          referenceNumber: '',
          roomName: '',
          perKilo: '',
          unitCost: '',
          supplierName: '',
        },
        errorMsg: '',
      }
    ));
    this.toggleModal('New');
    this.handleSubmit = (e) => { this.submitTransactionForm(e); };
  }

  reportToggle(e, stockItemId, productId) {
    e.preventDefault();
    e.stopPropagation();
    this.executeModal = 'inventoryreport';
    this.setState({
      formdata: {
        productid: productId,
        locationid: this.locationID,
      },
    });
    this.toggleModal();
    this.handleSubmit = (ev) => { this.submitReport(ev, stockItemId); };
  }

 async submitReport(e, id) {
  e.preventDefault();
  const { list } = this.state;
  const form = document.getElementById('warehouseInventoryReport_form');
  const formdata = new FormData(form);
  formdata.append('inventory_control_id', id);
  formdata.append('location_id', this.locationID);
  formdata.append('added_by', this.userdata.user_id);

  try {
    const result = await CommonService.insertData('submitwarehousereport', formdata, false);
    if (result) {
      if (result.result === true) {
        list.filter((resp) => {
          if (resp.inventory_control_id === id) {
              resp.stock_balance_actual = result.listdata.stock_balance_actual;
              resp.flag = 1;
          }
          return resp;
        });
        this.setState({ list, modal: false });
      } else {
        this.setState({ errorMsg: result.msg });
      }
    } else {
      swal('', 'Failed to add inventory!', 'danger');
    }
  } catch (err) {
    console.log(err);
  }
  this.isLoading = true;
}

  async addSubmitForm(e) {
    e.preventDefault();
    // const { list } = this.state;
    const form = document.getElementById('insertInventory_form');
    const formdata = new FormData(form);
    formdata.append('location_id', this.locationID);
    formdata.append('added_by', this.userdata.user_id);

    try {
      const result = await CommonService.insertData('addwarehouseinventory', formdata, false);
      if (result) {
        if (result.msg === true) {
          this.onLoadInventory();
          this.setState({ errorMsg: '', modal: false });

          swal({
            title: 'New Stock was added!',
            text: 'Would you like to add a new stock?',
            icon: 'success',
            closeOnClickOutside: false,
            buttons: {
              no: 'NOPE',
              yes: 'ADD NEW',
            },
          }).then((name) => {
            name = name.toLowerCase();

            if (name === 'yes') {
              this.addToggle();
            }
          });
        } else {
          this.setState({ errorMsg: result.msg });
        }
      } else {
        swal('', 'Failed to add inventory!', 'danger');
      }
    } catch (err) {
      console.log(err);
    }
    this.isLoading = true;
  }

  async submitTransactionForm(e) {
    e.preventDefault();
    const form = document.getElementById('insertTransaction_form');
    const formdata = new FormData(form);
    formdata.append('location_id', this.locationID);
    formdata.append('added_by', this.userdata.user_id);

    try {
      const result = await CommonService.insertData('addtransactionformwarehouse', formdata, false);
      if (result) {
        if (result.msg === true) {
          this.onLoadInventory();
          this.setState({ errorMsg: '', modal: false });

          swal({
            title: 'New Transaction was added!',
            text: 'Would you like to add a new transaction?',
            icon: 'success',
            closeOnClickOutside: false,
            buttons: {
              no: 'NOPE',
              yes: 'ADD NEW',
            },
          }).then((name) => {
            name = name.toLowerCase();

            if (name === 'yes') {
              this.addTransaction();
            }
          });
        } else {
          this.setState({ errorMsg: result.msg });
        }
      } else {
        swal('', 'Failed to add inventory!', 'danger');
      }
    } catch (err) {
      console.log(err);
    }
    this.isLoading = true;
  }

  toggleModal(text = '') {
    this.setState(prevState => ({ modal: !prevState.modal }));
    if (text) {
      this.setState({ title: text });
    }
  }

  render() {
    const {
      list, errorMsg, modal, formdata, title, warehouseData, goTo, goToPage,
    } = this.state;
    const { itemID } = this.props;

    if (itemID == null) {
      return <Redirect to="/login" />;
    }

    if (goTo === true) {
      return <Redirect to={{ pathname: goToPage, state: { prevpage: `/inventory/warehouse/dashboard/${this.locationID}` } }} />;
    }

    // for search date
    let inventoryDate = new Date();
    let storageDate = new Date();

    if (localStorage.getItem('warehouseInventoryDate') !== null) {
      const storageData = JSON.parse(localStorage.getItem('warehouseInventoryDate'));
      storageDate = new Date(storageData.date);

      let formdate = new Date();
      if (formdata.deliveryDate) {
        formdate = new Date(formdata.deliveryDate);
      }


      inventoryDate = formdata.deliveryDate !== undefined && formdata.deliveryDate !== this.currDate ? formdate : storageDate;
    }

    return (
      <Col md={12}>
        {
          this.executeModal === 'addinventory' ? (
            <AddInventoryModal
              title={`${title} Inventory`}
              icon="fa fa-plus"
              btn="Add Inventory"
              modal={modal}
              toggle={this.toggleModal}
              handleChange={this.handleChange}
              postValue={formdata}
              handleSubmit={this.handleSubmit}
              errorMsg={errorMsg}
              locationID={formdata.location_id}
              locationType="1"
            />
          ) : this.executeModal === 'addtransaction' ? (
            <AddTransactionModal
              title="Stock Withdrawal"
              icon="fa fa-plus"
              btn="Add Transaction"
              modal={modal}
              toggle={this.toggleModal}
              handleChange={this.handleChange}
              handleSubmit={this.handleSubmit}
              errorMsg={errorMsg}
              postValue={formdata}
              locationID={formdata.location_id}
              locationType="1"
            />
          ) : this.executeModal === 'inventoryreport' ? (
            <InventoryReport
              icon="fa fa-plus"
              modal={modal}
              toggle={this.toggleModal}
              postValue={formdata}
              handleChange={this.handleChange}
              handleSubmit={this.handleSubmit}
              errorMsg={errorMsg}
            />
          ) : ''
        }
        <Card className="panel panel--primary" id="users_table">
          <CardBody className="panel__body">
            <div className="panel__title bg_blue">
              <h5 className="bold-text">{warehouseData.warehouseName}</h5>
              <div className="panel__btns">
                {
                  this.userdata && (this.userdata.type !== '5') && (
                    <Button onClick={this.addToggle} className="rounded text-white" size="sm" outline>Add Inventory</Button>
                  )
                }

                {
                  this.userdata && (this.userdata.type !== '6') && (
                    <Button onClick={this.addTransaction} className="rounded text-white" size="sm" outline>Withdraw</Button>
                  )
                }
                {
                  this.userdata && (this.userdata.type === '1' || this.userdata.type === '5' || this.userdata.type === '6') && (
                    <Link className="rounded text-white btn btn-sm btn-outline-secondary btn-awesome" to="/inventory/warehouse/list">
                      <i className="fa fa-arrow-left" />
                      <span>Back</span>
                    </Link>
                  )
                }
              </div>
            </div>
            <div className="panel__content">
              { this.noreports && (
                <div className="notif_msg full-width clearfix notheadnotif">
                  <Alert color="warning" className="alert--colored">
                    <div className="alert__content">
                      <div>You have an unsubmitted report from {this.reportdate !== '' ? <strong className="text-red">{this.reportdate}</strong> : 'Yesterday' } inventory.</div>
                    </div>
                  </Alert>
                </div>
                )
              }

              <Row className="p-x-4">
                {
                  this.userdata.type && (this.userdata.type !== '1' && this.userdata.type !== '4') && (
                    <Col md={12} lg={4} className="p-x-6">
                      <div className="stock-box__container stock-sm stock-block">
                        <div className="stock-box stock-aqua outline">
                          <div className="stock-box__icon"><i className="fa fa-boxes" /></div>
                          <h3 className="stock-box__num">{warehouseData && warehouseData.total_beginning !== '0' ? `${warehouseData.total_beginning} kgs.` : 0}</h3>
                          <h4 className="stock-box__text">Total Beginning</h4>
                        </div>
                      </div>
                    </Col>
                  )
                }

                {
                  this.userdata.type && (this.userdata.type === '1' || this.userdata.type === '4') && (
                  <Col md={12} lg={4} className="p-x-6">
                    <div className="stock-box__container stock-sm stock-block">
                      <div className="stock-box stock-aqua outline">
                        <div className="stock-box__icon"><i className="fa fa-boxes" /></div>
                        <h3 className="stock-box__num">&#x20b1;{warehouseData && warehouseData.grand_total !== '0' ? `${warehouseData.grand_total}` : 0}</h3>
                        <h4 className="stock-box__text">Grand Total</h4>
                      </div>
                    </div>
                  </Col>
                  )
                }
                <Col md={12} lg={4} className="p-x-6">
                  <div className="stock-box__container stock-sm stock-block">
                    <Button className="stock-box stock-green outline" onClick={this.goTo} data-href={`/stockstracker/${this.locationID}/received/list`}>
                      <div className="stock-box__icon"><i className="fa fa-dolly-flatbed" /></div>
                      <h3 className="stock-box__num">{warehouseData && warehouseData.receiving_report !== '0' ? `${warehouseData.receiving_report} kgs.` : 0}</h3>
                      <h4 className="stock-box__text">Stock Received</h4>
                    </Button>
                  </div>
                </Col>
                <Col md={12} lg={4} className="p-x-6">
                  <div className="stock-box__container stock-sm stock-block">
                    <Button className="stock-box stock-red outline" onClick={this.goTo} data-href={`/stockstracker/${this.locationID}/stockout/list`}>
                      <div className="stock-box__icon"><i className="fa fa-truck-loading" /></div>
                      <h3 className="stock-box__num">{warehouseData && warehouseData.total_transfer !== '0' ? `${warehouseData.total_transfer} kgs.` : 0}</h3>
                      <h4 className="stock-box__text">Stock Withdrawn</h4>
                    </Button>
                  </div>
                </Col>

                <Col md={12} lg={4} className="p-x-6">
                  <div className="stock-box__container stock-sm stock-block">
                    <Button className="stock-box stock-purple outline" onClick={this.goTo} data-href={`/stockstracker/${this.locationID}/stocksold/list`}>
                      <div className="stock-box__icon"><i className="fa fa-chart-line" /></div>
                      <h3 className="stock-box__num">{warehouseData && warehouseData.withdrawal_report !== '0' ? `${warehouseData.withdrawal_report} kgs.` : 0}</h3>
                      <h4 className="stock-box__text">Stock Sold</h4>
                    </Button>
                  </div>
                </Col>
                <Col md={12} lg={4} className="p-x-6">
                  <div className="stock-box__container stock-sm stock-block">
                    <div className="stock-box stock-orange outline">
                      <div className="stock-box__icon"><i className="fa fa-pallet" /></div>
                      <h3 className="stock-box__num">{warehouseData && warehouseData.stock_balance !== '0' ? `${warehouseData.stock_balance} kgs.` : 0}</h3>
                      <h4 className="stock-box__text">Stock Balance</h4>
                    </div>
                  </div>
                </Col>
                <Col md={12} lg={4} className="p-x-6">
                  <div className="stock-box__container stock-sm stock-block">
                    <div className="stock-box stock-blue">
                      <div className="stock-box__icon"><i className="fa fa-calendar-day" /></div>
                      <h3 className="stock-box__num">{Moment(storageDate).format('MMMM DD, YYYY')}</h3>
                      <h4 className="stock-box__text">Inventory Date</h4>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
            <div className="panel__content">
              {/* Search Form */}
              <div className="float-right">
                <form className="form form--horizontal" onSubmit={this.changeInventoryDate}>
                    <div className="form__form-group m-b-10">
                      <span className="form__form-group-label text-right">Date:</span>
                      <div className="form__form-group-field">
                          <div className="form__form-group-icon">
                            <CalendarIcon />
                          </div>
                          <div className="date-picker">
                            <DatePicker
                              name="inventoryDate"
                              selected={inventoryDate}
                              popperPlacement="top"
                              onChange={e => this.handleChange(e, 'date')}
                            />
                          </div>
                          <button type="submit" className="form__form-group-button bg-primary"><i className="fa fa-search" /></button>
                      </div>
                    </div>
                </form>
              </div>

              <Table responsive hover striped className="doResTable">
                <thead>
                  <tr>
                    <th>Product Name</th>
                    <th className="text-center">Beginning</th>
                    <th className="text-center">Received</th>
                    <th className="text-center">Transfered Stock</th>
                    <th className="text-center">Sold</th>
                    <th className="text-center">Inventory Date</th>
                    <th className="text-center">New Balance</th>
                    <th className="text-center">Actual Count</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    list !== false || list.length > 0 ? list.map((item) => {
                      const stockBeginning = global.parseToNumber(item.stock_beginning, 'float');
                      const stockReceive = global.parseToNumber(item.stock_receive, 'float');
                      const stockTransfer = global.parseToNumber(item.stock_transfer, 'float');
                      const stockOut = global.parseToNumber(item.stock_out, 'float');
                      const stockBalance = global.parseToNumber(item.stock_balance, 'float');
                      const stockBalanceActual = global.parseToNumber(item.stock_balance_actual, 'float');

                      return (
                        <tr key={item.inventory_control_id} className="text-center" onClick={this.goTo.bind(this)} data-href={`/inventory/warehouse/distribution/${item.inventory_control_id}`}>
                            <td className="text-left">{item.product_name}</td>
                            <td className="text-center">{stockBeginning !== 0 ? `${global.numberFormat(stockBeginning)} kgs.` : <b className="text-red">0</b>}</td>
                            <td className="text-center">{stockReceive !== 0 ? `${global.numberFormat(stockReceive)} kgs.` : <b className="text-red">0</b>}</td>
                            <td className="text-center">{stockTransfer !== 0 ? `${global.numberFormat(stockTransfer)} kgs.` : <b className="text-red">0</b>}</td>
                            <td className="text-center">{stockOut !== 0 ? `${global.numberFormat(stockOut)} kgs.` : <b className="text-red">0</b>}</td>
                            <td className="text-center">{item.date_added}</td>
                            <td className="text-center">{stockBalance !== 0 ? `${global.numberFormat(stockBalance)} kgs.` : <b className="text-red">0</b>}</td>
                            <td className="text-center">{stockBalanceActual !== 0 ? `${global.numberFormat(stockBalanceActual)} kgs.` : <b className="text-red">0</b>}</td>
                            {
                              item.flag === '0' ? (
                                <td>
                                  <Button color="info" id="forwardTP" className="btn-xs" onClick={e => this.reportToggle(e, item.inventory_control_id, item.product_id)} outline><span className="fa fa-share" /></Button>
                                  <UncontrolledTooltip placement="bottom" target="forwardTP">Submit Report</UncontrolledTooltip>
                                </td>
                              ) : <td>--</td>
                            }
                        </tr>
                      );
                    }) : (
                      <tr className="text-center">
                        <td colSpan="12">No data available..</td>
                      </tr>
                    )
                  }
                </tbody>
              </Table>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

export default withTranslation('common')(WarehouseDashboard2);
